import { Link } from 'react-router-dom';
import { CalendarDays, MapPin } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { useEvents } from '@/lib/queries';
import { dateTime, money } from '@/lib/format';
import { Spinner, ErrorNote } from '@/components/Layout';

export function Events() {
  const events = useEvents();
  const { session } = useAuth();
  if (events.isLoading) return <Spinner />;
  if (events.error) return <ErrorNote>We couldn't load events. Please refresh the page.</ErrorNote>;
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Upcoming events</h1>
        <p className="mt-1 text-sm text-ink-500">Gradings, courses and Gasshuku.</p>
      </div>
      {!events.data?.length && <p className="card text-sm text-ink-500">No events are open yet. Check back soon.</p>}
      <ul className="space-y-4">
        {events.data?.map(e => (
          <li key={e.id} className="card">
            <p className="text-xs font-semibold uppercase tracking-wide text-brand-700">{e.type}</p>
            <h2 className="mt-1 text-lg font-semibold"><Link to={`/events/${e.slug}`} className="hover:underline">{e.title}</Link></h2>
            <div className="mt-2 flex flex-wrap gap-x-5 gap-y-1 text-sm text-ink-500">
              <span className="flex items-center gap-1.5"><CalendarDays size={15} />{dateTime(e.starts_at)}</span>
              {e.venue && <span className="flex items-center gap-1.5"><MapPin size={15} />{e.venue}</span>}
            </div>
            {e.description && <p className="mt-3 text-sm">{e.description}</p>}
            {e.options.length > 0 && (
              <ul className="mt-4 grid gap-2 sm:grid-cols-3">
                {[...e.options].filter(o => o.active !== false).sort((a, b) => a.sort_order - b.sort_order).map(o => (
                  <li key={o.id} className="flex justify-between rounded-sm bg-stone-50 px-3 py-2 text-sm"><span>{o.name}</span><span className="font-semibold">{money(o.price_pence)}</span></li>
                ))}
              </ul>
            )}
            <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
              <p className="text-xs text-ink-500">{e.requires_active_membership ? 'EGKA members only.' : 'Open to everyone.'}{e.registration_closes_at && ` Booking closes ${dateTime(e.registration_closes_at)}.`}</p>
              <span className="flex gap-2">
                <Link to={`/events/${e.slug}`} className="btn-ghost border border-stone-300">Details</Link>
                <Link to={session ? `/events/${e.id}/book` : '/signin'} className="btn-primary">{session ? 'Book' : 'Sign in to book'}</Link>
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
